export default "<p>\n  plans-menu works!\n</p>\n";